import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
    formPaper: {
        padding: theme.spacing(3),
        paddingTop: theme.spacing(1),
    },
    formDivider: {
        marginBottom: theme.spacing(3),
    },
    formSection: {
        marginBottom: theme.spacing(3),
    },
    formSectionHeading: {
        fontSize: '1.1rem',
    },
}));
